import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Card,
  Typography,
  Divider,
  Chip,
  Tooltip,
  responsiveFontSizes,
  AlertTitle,
  IconButton,
} from "@mui/material";
import moment from "moment";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ValidationModal from "./modals/ValidationModal";
import NewAlertsModal from "./modals/NewAlertsModal";
import PromptModal from "./modals/PromptModal";
import AlertReleaseFormModal from "./modals/AlertReleaseModal";
import DisseminateModal from "./modals/DisseminateModal";
import NotificationSoundFolder from "../../audio/notif_sound.mp3";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import LibraryAddCheckRoundedIcon from "@mui/icons-material/LibraryAddCheckRounded";

import {
  getCandidateAlert,
  sendMessage,
  getReleasedMessages,
  getTempMoms,
  getContacts,
  checkIfRoutine,
} from "../../apis/AlertGeneration";

import {
  Cancel,
  Check,
  CheckCircle,
  Info,
  Landscape,
} from "@material-ui/icons";
import UpdateMomsModal from "./modals/UpdateMomsModal";
import OnDemandModal from "./modals/OnDemandModal";
import { CBEWSL_SITE, CBEWSL_SITE_CODE, CBEWSL_SITE_NAME } from "../../host";
import tempAlertGen from "../data/alert_gen.json";

const alert_level_colors = [
  { alert_level: 0, color: "#c5e0b4" },
  { alert_level: 1, color: "#FCEE27" },
  { alert_level: 2, color: "#F8991D" },
  { alert_level: 3, color: "#e11e1ec9" },
];
function capitalizeFirstLetter(str, every_word = false) {
  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

  if (every_word) {
    const arr = str.split(" ");
    const cap_arr = arr.map((s) => capitalize(s));

    return cap_arr.join(" ");
  }

  return capitalize(str);
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TempMomsTable(props) {
  const { momsData, setSelectedMomsData, setIsOpenUpdateMomsModal } = props;
  const [moms_list, setMomsList] = useState([]);

  useEffect(() => {
    if (momsData) {
      let temp = [];
      momsData.forEach((row, index) => {
        const { moms_list } = row;
        if (moms_list.length > 0) {
          temp.push(row);
        }
      });

      setMomsList(temp);
    }
  }, []);

  const selectMoms = (data) => {
    setSelectedMomsData(data);
    setIsOpenUpdateMomsModal(true);
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <TableContainer
          component={Paper}
          style={{
            width: "auto",
            marginLeft: 48,
            marginRight: 48,
            marginBottom: 48,
          }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Feature Type</TableCell>
                <TableCell align="left">Feature Name</TableCell>
                <TableCell align="left">Observance Timestamp</TableCell>
                <TableCell align="left">Details</TableCell>
                <TableCell align="left">Location</TableCell>
                <TableCell align="left">Remarks</TableCell>
                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {moms_list.length > 0 &&
                moms_list.map((row, index) => {
                  const { uploads, moms_list, temp_moms_id } = row;
                  return moms_list.map((moms_row, index) => {
                    const {
                      feature_type,
                      feature_name,
                      observance_ts,
                      remarks,
                      location,
                      report_narrative,
                    } = moms_row;
                    return (
                      <TableRow
                        key={temp_moms_id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="left">{feature_type}</TableCell>
                        <TableCell align="left">{feature_name}</TableCell>
                        <TableCell align="left">
                          {moment(observance_ts).format("LLL")}
                        </TableCell>
                        <TableCell align="left">{remarks}</TableCell>
                        <TableCell align="left">{location}</TableCell>
                        <TableCell align="left">{report_narrative}</TableCell>
                        <TableCell align="left">
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => selectMoms(row)}
                          >
                            Validate
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  });
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

function HeaderAlertInformation(props) {
  const { onGoingData, routineData, ewiTemplates } = props;
  const [alert_level, setAlertLevel] = useState(0);
  const [data_timestamp, setDataTimestamp] = useState(moment().format("LLL"));
  const [latest_triggers, setLatestTriggers] = useState([]);
  const [responses, setResponses] = useState({
    barangay_response: "",
    community_response: "",
    lewc_response: "",
    mlgu_response: "",
    plgu_response: "",
  });
  const [validity, setValidity] = useState(null);
  const [server_time, setServerTime] = useState("");

  useEffect(() => {
    if (onGoingData.length > 0) {
      const {
        highest_event_alert_level,
        latest_event_triggers,
        public_alert_symbol,
      } = onGoingData[0];
      const template = ewiTemplates.find(
        (e) => e.alert_level === public_alert_symbol.alert_level
      );
      setAlertLevel(public_alert_symbol.alert_level);
      setResponses(template);
      const triggers = latest_event_triggers.map((row, index) => {
        const { internal_sym, trigger_misc } = row;
        const { trigger_symbol } = internal_sym;
        const { trigger_hierarchy, alert_level } = trigger_symbol;
        const { trigger_source } = trigger_hierarchy;
        let template = ewiTemplates.find(
          (e) =>
            e.trigger === trigger_source &&
            e.alert_level === alert_level
        );
        if (trigger_source === "on demand") {
          const { on_demand } = trigger_misc;
          const { eq_id } = on_demand;
          if (eq_id) {
            template = ewiTemplates.find(
              (e) =>
                e.alert_level === alert_level &&
                e.trigger === "earthquake"
            );
          } else {
            template = ewiTemplates.find(
              (e) =>
                e.alert_level === alert_level &&
                e.trigger === "rainfall"
            );
          }
        }
        if (template) {
          return template;
        }
      });

      setLatestTriggers(triggers);
    } else {
      if (ewiTemplates.length > 0) {
        const template = ewiTemplates.find((e) => e.alert_level === 0);
        setResponses(template);
        setLatestTriggers([template]);
        setAlertLevel(0);
      }
      // setValidity(`valid until ${moment().format("LLL")}`)
    }
  }, [onGoingData]);

  useEffect(() => {
    setInterval(() => {
      let dt = moment().format("MMMM D, YYYY, h:mm A");
      setServerTime(dt);
    }, 1000);
  }, []);

  return (
    <Grid
      container
      justifyContent={"center"}
      alignItems={"center"}
      textAlign={"center"}
    >
      <Grid
        item
        xs={12}
        style={{
          width: "100%",
          margin: 50,
        }}
      >
        <Card
          style={{
            padding: 10,
            backgroundColor: alert_level_colors.find(
              (e) => e.alert_level === alert_level
            ).color,
            borderTopLeftRadius: 60,
            borderTopRightRadius: 0,

            // maxHeight: "200px",
            // backgroundColor: "blue",
          }}
        >
          <Grid container spacing={1}>
            <Grid
              item
              xs={3}
              style={{ alignSelf: "center", maxHeight: "200px" }}
            >
              <Typography variant="h3"><b>ALERT LEVEL {alert_level}</b></Typography>
              <Typography variant="h5">
                {moment(data_timestamp).format("MMMM D, YYYY, h:mm A")}
              </Typography>
            </Grid>
            <Grid
              item
              xs={9}
              overflow={"auto"}
              style={{
                alignSelf: "center",
                borderLeft: "solid 2px rgba(0, 0, 0, 0.5)",
                marginTop: 8,
                padding: 25,
                maxHeight: "370px",
              }}
            >
              <Typography variant="h6" gutterBottom align="left">
                <strong>
                  Description:{" "}
                  {latest_triggers.length > 0 &&
                    latest_triggers.map((row, index) => {
                      if (row) {
                        const { sms_trigger_description } = row;
                        return `${sms_trigger_description} `;
                      }
                      return "";
                    })}
                  <br />
                  {validity && validity}
                </strong>
              </Typography>
              <br />
              <Typography variant="h6" gutterBottom align="left">
                <strong> Recommended Responses:</strong>
              </Typography>
              <Grid style={{ paddingLeft: 20 }}>
                <Typography variant="body1" gutterBottom align="left" marginBottom={1.5} marginTop={1.5}>
                  <strong>Komunidad:</strong>{" "}
                  {responses.dash_community_response
                    ? responses.dash_community_response
                    : "N/A"}
                </Typography>
                <Typography variant="body1" gutterBottom align="left" marginBottom={1.5}>
                  <strong>LEWC:</strong>{" "}
                  {responses.dash_lewc_response ? responses.dash_lewc_response : "N/A"}
                </Typography>
                <Typography variant="body1" gutterBottom align="left" marginBottom={1.5}>
                  <strong>BLGU:</strong>{" "}
                  {responses.dash_barangay_response
                    ? responses.dash_barangay_response
                    : "N/A"}
                </Typography>
                <Typography variant="body1" gutterBottom align="left" marginBottom={1.5}>
                  <strong>MLGU:</strong>{" "}
                  {responses.dash_mlgu_response ? responses.dash_mlgu_response : "N/A"}
                </Typography>
                <Typography variant="body1" gutterBottom align="left" marginBottom={1.5}>
                  <strong>PLGU:</strong>{" "}
                  {responses.dash_plgu_response ? responses.dash_plgu_response : "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}

function GroundMeasurementReminderPanel(props) {
  const {
    setIsOpenGroundMeasReminder,
    is_open_ground_meas_reminder,
    onGoingAlerts,
    extendedAlerts,
    routine,
    groundMeasReminder,
  } = props;
  console.log("props", props);
  const [event_message, setEventMessage] = useState("");
  const [copyMessage, setCopyMessage] = useState("");
  const [copyStatus, setCopyStatus] = useState(false);
  const [is_routine, setIsRoutine] = useState(false);

  const onCopyText = () => {
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 5000);
  };

  useEffect(() => {
    checkIfRoutine(CBEWSL_SITE_CODE, (result) => {
      setIsRoutine(result.is_routine);
    });
  }, []);

  useEffect(() => {
    const checkGroundMeasurementDisplayConditions = () => {
      let current_alert_level = 0;
      if (onGoingAlerts.length > 0) {
        const { public_alert_symbol } = onGoingAlerts[0];
        const { alert_level } = public_alert_symbol;
        current_alert_level = alert_level;
      }

      const ground_meas_reminder =
        groundMeasReminder &&
        groundMeasReminder.find((e) => e.alert_level === current_alert_level);

      const alert_levels = [1, 2, 3];
      const isRoutine = is_routine;
      let isEvent = false;

      const format = "HH:mm:ss";
      const current_time = moment(moment(), format);
      const beforeTime = moment("05:30:00", format);
      const afterTime = moment("11:30:00", format);

      let isTimeInRange = current_time.isBetween(beforeTime, afterTime); //if routine
      if (alert_levels.includes(current_alert_level)) {
        isTimeInRange =
          current_time.isBetween(
            moment("05:30:00", format),
            moment("07:30:00", format)
          ) ||
          current_time.isBetween(
            moment("09:30:00", format),
            moment("11:30:00", format)
          ) ||
          current_time.isBetween(
            moment("13:30:00", format),
            moment("15:30:00", format)
          ); //if event
        isEvent = true;
      }

      return {
        toDisplay: (isEvent && isTimeInRange) || (isRoutine && isTimeInRange),
        reminder: ground_meas_reminder,
      };
    };

    const { toDisplay, reminder } = checkGroundMeasurementDisplayConditions();
    if (toDisplay && reminder) {
      const { additional_reminder, reminder: reminder_msg } = reminder;
      let greetings = "";
      const currentHour = parseInt(moment().format("HH"));

      const is_translated = reminder_msg.includes("<greetings-other>");

      if (currentHour == 0) {
        greetings = is_translated ? "gabii" : "gabi";
      } else if (currentHour <= 11) {
        greetings = is_translated ? "buntag" : "umaga";
      } else if (currentHour == 12) {
        greetings = is_translated ? "udto" : "tanghali";
      } else if (currentHour < 18) {
        greetings = "hapon";
      } else {
        greetings = is_translated ? "gabii" : "gabi";
      }
      const part1 = additional_reminder;
      const part2 = reminder_msg
        .replace("<greetings>", greetings)
        .replace("<greetings-other>", greetings);

      setEventMessage(<>{part1}<br/><br/><b><i>{part2}</i></b></>);
      setCopyMessage(part2);
      setIsOpenGroundMeasReminder(true);
    }
  }, [is_routine, onGoingAlerts, groundMeasReminder]);

  return (
    <Fragment>
      {is_open_ground_meas_reminder && (
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              width: "100%",
              marginTop: 50,
              marginLeft: 50,
              marginRight: 50,
            }}
          >
            <Alert
              variant="outlined"
              severity="info"
              onClose={() => {
                setIsOpenGroundMeasReminder(false);
              }}
              style={{ boxShadow: "none", whiteSpace: "pre-line" }}
            >
              <AlertTitle>
                <Typography>Ground Measurement Reminder</Typography>
              </AlertTitle>
              {event_message}
              <CopyToClipboard text={copyMessage} onCopy={onCopyText}>
                <Tooltip
                  title={
                    copyStatus
                      ? "Ground measurement reminder copied to clipboard!"
                      : "Copy to Clipboard"
                  }
                >
                  <IconButton color="primary" size="medium">
                    {copyStatus ? (
                      <LibraryAddCheckRoundedIcon fontSize="inherit" />
                    ) : (
                      <ContentCopyRoundedIcon fontSize="inherit" />
                    )}
                  </IconButton>
                </Tooltip>
              </CopyToClipboard>
            </Alert>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}

function ExtendedAccordionPanel(props) {
  const { data, key, handleDisseminate } = props;
  const [header_color, setHeaderColor] = useState("");
  const [data_timestamp, setDataTimestamp] = useState(null);
  const [alert_level, setAlertLevel] = useState(0);
  const [ext_day, setExtDay] = useState(null);
  const [isMessageSend, setIsMessageSend] = useState(null);

  const checkReleasedMessage = (release_id) => {
    getReleasedMessages(release_id, (response) => {
      const { status, data } = response;
      if (status) {
        setIsMessageSend(data ? true : false);
      }
    });
  };
  useEffect(() => {
    if (data) {
      const { releases, public_alert_symbol, day } = data;
      setExtDay(day);
      const { data_ts, release_id } = releases[0];
      checkReleasedMessage(release_id);
      setDataTimestamp(data_ts);
      const { alert_level: alertLevel } = public_alert_symbol;
      setAlertLevel(alertLevel);
      const colors = alert_level_colors.find(
        (e) => e.alert_level === alertLevel
      );
      setHeaderColor(colors.color);
    }
  }, [data]);

  return (
    <Fragment>
      <Accordion
        style={{ marginLeft: 48, marginRight: 48, marginBottom: 48 }}
        expanded={true}
        // onChange={handleChange(`pending_panel_${key}`)}
        key={`pending_panel_${key}`}
      >
        <AccordionSummary
          // expandIcon={<ExpandMoreIcon />}
          aria-controls={`pending-panel-content-${key}`}
          style={{ backgroundColor: `${header_color}` }}
          id={`pending-panel-header-${key}`}
        >
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            textAlign={"left"}
          >
            <Grid item xs={3}>
              <Typography variant="h6">
                {`Alert level ${alert_level}`}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {data_timestamp && (
                <Typography variant="h6">
                  Data Timestamp:{" "}
                  {moment(data_timestamp).format("MMMM D, YYYY, h:mm A")}
                </Typography>
              )}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <br />

          <Grid container spacing={4}>
            <Grid item md={12} style={{ textAlign: "center" }}>
              {ext_day && (
                <Typography variant="body1">
                  Day {ext_day} of 3-day extended monitoring
                </Typography>
              )}
            </Grid>
            <Grid item md={12}>
              <Tooltip
                title={
                  isMessageSend ? "Warning sent!" : "Please disseminate warning"
                }
                placement="top"
              >
                <Button
                  onClick={() => handleDisseminate(data)}
                  size="small"
                  variant="contained"
                  color="success"
                  style={{
                    float: "right",
                    marginTop: 50,
                    textTransform: "none",
                  }}
                >
                  Disseminate Warning
                </Button>
              </Tooltip>
            </Grid>
          </Grid>

          <br />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
}

function PendingAccordionPanel(props) {
  const {
    data,
    key,
    expanded,
    handleChange,
    navigate,
    setTriggers,
    setIsOpenValidationModal,
    setAlertTrigger,
    handleRelease,
  } = props;
  const {
    trigger_list_arr,
    release_details,
    general_status,
    public_alert_level,
  } = data;
  let data_timestamp;
  if (release_details) {
    const { data_ts } = release_details;
    data_timestamp = data_ts;
  }

  const charts = ["subsurface", "surficial", "rainfall", "earthquake"];
  const [disable_generate_button, setDisableGenerateButton] = useState(true);
  const [header_color, setHeaderColor] = useState("");

  const viewChart = (chart) => {
    const url = `${window.location.origin}${chart}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openValidateModal = (trigger) => {
    setIsOpenValidationModal(true);
    setAlertTrigger(trigger);
  };

  useEffect(() => {
    if (general_status === "routine" || general_status === "extended") {
      setDisableGenerateButton(false);
    }

    if (trigger_list_arr) {
      const button_status = trigger_list_arr.find(
        (e) => e.validating_status === null || e.validating_status === 0
      );
      setDisableGenerateButton(button_status);
    }
    const colors = alert_level_colors.find(
      (e) => e.alert_level === public_alert_level
    );
    setHeaderColor(colors.color);
  }, [data]);

  return (
    <Fragment>
      <Accordion
        style={{ marginLeft: 48, marginRight: 48, marginBottom: 48 }}
        expanded={true}
        // onChange={handleChange(`pending_panel_${key}`)}
        key={`pending_panel_${key}`}
      >
        <AccordionSummary
          // expandIcon={<ExpandMoreIcon />}
          aria-controls={`pending-panel-content-${key}`}
          style={{ backgroundColor: `${header_color}` }}
          id={`pending-panel-header-${key}`}
        >
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            textAlign={"left"}
          >
            <Grid item xs={4}>
              <Typography variant="h6">
                {`Alert level ${public_alert_level}`}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              {data_timestamp && (
                <Typography variant="h6">
                  Data Timestamp:{" "}
                  {moment(data_timestamp).format("MMMM D, YYYY, h:mm A")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={2}>
              {general_status && (
                <Typography variant="h6" style={{ float: "right" }}>
                  {capitalizeFirstLetter(general_status)}
                </Typography>
              )}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <br />
          {trigger_list_arr && trigger_list_arr.length > 0 ? (
            trigger_list_arr.map((row, index) => {
              const { tech_info, trigger_type, ts_updated, validating_status } =
                row;
              const has_chart = charts.includes(trigger_type);
              return (
                <Grid
                  container
                  style={{ textAlign: "center", marginBottom: 15 }}
                >
                  <Grid item md={2}>
                    <Typography variant="h6">Trigger</Typography>
                    <Typography>
                      {capitalizeFirstLetter(trigger_type)}
                    </Typography>
                  </Grid>
                  <Grid item md={3}>
                    <Typography variant="h6">Trigger timestamp</Typography>
                    <Typography>
                      {moment(ts_updated).format("MMMM D, YYYY, h:mm A")}
                    </Typography>
                  </Grid>
                  <Grid item md={5}>
                    <Typography variant="h6">Technical Information</Typography>
                    <Typography>{tech_info}</Typography>
                    {has_chart && (
                      <Button
                        size="small"
                        variant="contained"
                        style={{ marginTop: 5 }}
                        onClick={() => viewChart(`/${trigger_type}`)}
                      >
                        View Chart
                      </Button>
                    )}
                  </Grid>
                  <Grid item md={2} style={{ alignSelf: "center" }}>
                    {(validating_status === null ||
                      validating_status === 0) && (
                      <Chip
                        icon={<Info />}
                        label="Validate"
                        clickable
                        color="primary"
                        onClick={() => openValidateModal(row)}
                      />
                    )}
                    {validating_status === 1 && (
                      <Chip
                        icon={<CheckCircle />}
                        label="Valid"
                        color="success"
                        onClick={() => openValidateModal(row)}
                      />
                    )}

                    {validating_status === -1 && (
                      <Chip
                        icon={<Cancel />}
                        label="Invalid"
                        clickable
                        color="error"
                        onClick={() => openValidateModal(row)}
                      />
                    )}
                  </Grid>
                </Grid>
              );
            })
          ) : (
            <Grid container style={{ textAlign: "center" }}>
              <Grid item md={12}>
                {general_status === "routine" ? (
                  <Typography variant="body1" style={{ textAlign: "center" }}>
                    Please release routine monitoring
                  </Typography>
                ) : (
                  <Typography variant="body1" style={{ textAlign: "center" }}>
                    {general_status === "extended"
                      ? "Please generate warning for extended monitoring."
                      : "No new triggers."}
                  </Typography>
                )}
              </Grid>
            </Grid>
          )}
          <Grid container spacing={4}>
            <Grid item md={12}>
              <Button
                onClick={() => handleRelease(data)}
                size="small"
                variant="contained"
                color="success"
                disabled={disable_generate_button}
                style={{ float: "right", marginTop: 50, textTransform: "none" }}
              >
                Generate Warning
              </Button>
            </Grid>
          </Grid>

          <br />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
}

function LatestAccordionPanel(props) {
  const { data, key, expanded, handleChange, handleDisseminate, isRoutine } =
    props;
  const [header_color, setHeaderColor] = useState(null);
  const [data_timestamp, setDataTimestamp] = useState(null);
  const [trig_source, setTriggerSource] = useState("");
  const [alert_validity, setAlertValidity] = useState(null);
  const [rel_id, setReleaseId] = useState(null);
  const [latest_rel_id, setLatestReleaseId] = useState(null);
  const [tech_info, setTechInfo] = useState(null);
  const [trig_ts, setTriggerTimestamp] = useState(null);
  const [alert_level, setAlertLevel] = useState(0);
  const [isMessageSend, setIsMessageSend] = useState(null);
  const [alert_general_status, setAlertGeneralStatus] = useState("");

  const checkReleasedMessage = (release_id) => {
    getReleasedMessages(release_id, (response) => {
      const { status, data } = response;
      if (status) {
        setIsMessageSend(data ? true : false);
      }
    });
  };

  useEffect(() => {
    if (isRoutine) {
      const { data_ts, release_id } = data;
      setDataTimestamp(data_ts);
      const colors = alert_level_colors.find((e) => e.alert_level === 0);
      setHeaderColor(colors.color);
      setDataTimestamp(moment(data_ts).add(30, "minutes").format("LLL"));
      data.isRoutine = true;
      data.public_alert_level = 0;
      setAlertLevel(0);
      checkReleasedMessage(release_id);
      setAlertGeneralStatus("Routine");
    } else {
      if (data) {
        const {
          event,
          event_alert_id,
          internal_alert_level,
          releases,
          public_alert_symbol,
          is_onset_release,
          latest_event_triggers,
          ts_start,
          highest_event_alert_level,
          general_status,
        } = data;
        const { site, validity } = event;
        setAlertValidity(validity);
        if (latest_event_triggers.length > 0) {
          const {
            info,
            internal_sym,
            ts: trigger_ts,
            release_id: latest_event_trigger_release_id,
          } = latest_event_triggers[0];
          const { alert_description, trigger_symbol } = internal_sym;
          const {
            trigger_hierarchy: { trigger_source },
          } = trigger_symbol;
          const { release_time, data_ts, trigger_list, release_id } =
            releases[0];
          setAlertGeneralStatus(general_status);
          checkReleasedMessage(release_id);
          if (releases.length === 1) {
            setDataTimestamp(moment(data_ts).format("LLL"));
          } else {
            setDataTimestamp(moment(data_ts).add(30, "minutes").format("LLL"));
          }
          setTriggerSource(trigger_source);
          setReleaseId(release_id);
          setLatestReleaseId(latest_event_trigger_release_id);
          setTechInfo(info);
          setTriggerTimestamp(trigger_ts);
          const { alert_level: alertLevel, alert_symbol } = public_alert_symbol;
          setAlertLevel(alertLevel);
          const colors = alert_level_colors.find(
            (e) => e.alert_level === alertLevel
          );
          setHeaderColor(colors.color);
        }
      }
    }
  }, [data]);

  return (
    <Accordion
      style={{ marginLeft: 48, marginRight: 48, marginBottom: 48 }}
      expanded={true}
      onChange={handleChange(`event_panel_${key}`)}
      key={`event_panel_${key}`}
    >
      <AccordionSummary
        style={{ backgroundColor: `${header_color}` }}
        aria-controls={`event-panel-content-${key}`}
        id={`event-panel-header-${key}`}
      >
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          textAlign={"left"}
        >
          <Grid item xs={12} style={{ width: "100%" }}></Grid>
          <Grid item xs={2}>
            <Typography variant="h6">Alert level {alert_level}</Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography variant="h6" style={{ textAlign: "center" }}>
              Date and Time:{" "}
              {moment(data_timestamp).format("MMMM D, YYYY, h:mm A")}
            </Typography>
            {!isRoutine && (
              <Typography variant="h6" style={{ textAlign: "center" }}>
                Validity:{" "}
                {moment(alert_validity).format("MMMM D, YYYY, h:mm A")}
              </Typography>
            )}
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h6" style={{ float: "right" }}>
              {alert_general_status ? alert_general_status : "Ongoing"}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <br />

        {!isRoutine && latest_rel_id === rel_id ? (
          <Grid container style={{ textAlign: "center" }}>
            <Grid item md={3}>
              <Typography variant="h6">Trigger</Typography>
              <Typography>{capitalizeFirstLetter(trig_source)}</Typography>
            </Grid>
            <Grid item md={3}>
              <Typography variant="h6">Trigger timestamp</Typography>
              <Typography>
                {moment(trig_ts).format("MMMM D, YYYY, h:mm A")}
              </Typography>
            </Grid>
            <Grid item md={6}>
              <Typography variant="h6">Technical Information</Typography>
              <Typography>{tech_info}</Typography>
            </Grid>
            <Grid item md={12}>
              <Stack
                spacing={1}
                direction="row"
                justifyContent="flex-end"
                style={{ marginTop: 20 }}
              >
                <Tooltip
                  title={
                    isMessageSend
                      ? "Warning sent!"
                      : "Please disseminate warning"
                  }
                  placement="top"
                >
                  <Button
                    size="small"
                    variant="contained"
                    style={{ textTransform: "none" }}
                    startIcon={isMessageSend ? <Check /> : <Info />}
                    onClick={() => handleDisseminate(data)}
                  >
                    Disseminate Warning
                  </Button>
                </Tooltip>
              </Stack>
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ textAlign: "center" }}>
            <Grid item md={12}>
              <Typography>
                {isMessageSend ? "Warning sent!" : "Please disseminate warning"}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Stack
                spacing={1}
                direction="row"
                justifyContent="flex-end"
                style={{ marginTop: 20 }}
              >
                <Tooltip
                  title={
                    isMessageSend
                      ? "Warning sent!"
                      : "Please disseminate warning"
                  }
                  placement="top"
                >
                  <Button
                    size="small"
                    style={{ textTransform: "none" }}
                    variant="contained"
                    startIcon={isMessageSend ? <Check /> : <Info />}
                    onClick={() => handleDisseminate(data)}
                  >
                    Disseminate Warning
                  </Button>
                </Tooltip>
              </Stack>
            </Grid>
          </Grid>
        )}
        <br />
      </AccordionDetails>
    </Accordion>
  );
}
function OpCen2(props) {
  const [alertLevel, setAlertLevel] = useState("1");
  const [alertTs, setAlertTs] = useState(moment().format("LLLL"));
  const [expanded, setExpanded] = React.useState(false);
  const [is_validated, setIsValidated] = useState(false);
  const [is_open_validation_modal, setIsOpenValidationModal] = useState(false);
  const [is_open_new_alert_modal, setIsOpenNewAlertModal] = useState(true);
  const [is_open_prompt_modal, setIsOpenPromptModal] = useState(false);
  const [is_open_release_modal, setIsOpenReleaseModal] = useState(false);
  const [is_open_disseminate_modal, setIsOpenDisseminateModal] =
    useState(false);
  const [alert_trigger, setAlertTrigger] = useState("");
  const [disseminate_data, setDisseminateData] = useState("");
  const [notif_message, setNotifMessage] = useState("");
  const [triggers, setTriggers] = useState([]);
  const [monitoring_releases, setMonitoringReleases] = useState([]);
  const [is_open_update_moms_modal, setIsOpenUpdateMomsModal] = useState(false);
  const [moms_data, setMomsData] = useState(null);
  const [selected_moms_data, setSelectedMomsData] = useState(null);

  const [candidate_alerts, setCandidateAlerts] = useState([]);
  const [on_going_alerts, setOnGoingAlerts] = useState([]);
  const [extended_alerts, setExtendedAlerts] = useState([]);
  const [routine, setRoutine] = useState({ released_sites: [] });
  const [cbewsl_ewi_template, setEwiTemplates] = useState([]);
  const [alert_variant, setAlertVariant] = useState("success");
  const [all_contacts, setAllContacts] = useState([]);
  const [current_user, setCurrentUser] = useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [is_open_ondemand_modal, setIsOpenOndemandModal] = useState(false);
  const [is_open_ground_meas_reminder, setIsOpenGroundMeasReminder] =
    useState(false);
  const [ground_measurement_reminder, setGroundMeasurementReminder] =
    useState(null);

  const navigate = useNavigate();
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleValidate = (trigger) => {
    setAlertTrigger(trigger);
    setIsOpenValidationModal(!is_open_validation_modal);
  };

  const handleValidation = (message) => {
    setIsOpenValidationModal(!is_open_validation_modal);
    setNotifMessage(message);
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: message,
      confirmButtonColor: "#1976d2"
    });
  };

  const handleRelease = (trigger) => {
    trigger.is_event_valid = true;
    trigger.is_manually_lowered = false;
    setAlertTrigger(trigger);
    setIsOpenReleaseModal(!is_open_release_modal);
  };

  const handleSubmitRelease = (message, status) => {
    setIsOpenValidationModal(false);
    Swal.fire({
      icon: status,
      title: status === "success" ? "Success!" : "Error!",
      text: message,
      confirmButtonColor: "#1976d2"
    });
  };

  const handleDisseminate = (data) => {
    setDisseminateData(data);
    setIsOpenDisseminateModal(!is_open_disseminate_modal);
  };

  const generateDashboardData = () => {
    const temp_on_going_data = tempAlertGen;
    getCandidateAlert((data) => {
      const {
        candidate_alerts,
        on_going,
        ewi_templates,
        ground_meas_reminder,
      } = data;
      // setCandidateAlerts([JSON.parse(candidate_alerts)[1]]);

      const temp_candidate = JSON.parse(candidate_alerts);
      const temp_on_going = JSON.parse(on_going);
      const {
        latest,
        overdue,
        extended,
        routine: routine_data,
      } = temp_on_going;
      let temp = [];
      temp.push(...latest);
      temp.push(...overdue);
      setOnGoingAlerts(temp);
      if (!routine_data.released_sites) {
        routine_data.released_sites = [];
      }
      setEwiTemplates(ewi_templates);

      if (routine_data.released_sites) {
        routine_data.released_sites = routine_data.released_sites.filter(
          (e) => e.site_id === CBEWSL_SITE
        );
        setRoutine(routine_data);
      }
      setExtendedAlerts(extended);
      if (extended.length > 0) {
        const extended_site = extended.find((e) => e.event.site.site_id);
        if (extended_site) {
          setCandidateAlerts(
            temp_candidate.filter((e) => e.general_status === "extended")
          );
        }
      } else {
        setCandidateAlerts(temp_candidate);
      }
      setGroundMeasurementReminder(ground_meas_reminder);
    });
  };

  const generateMomsForValidation = () => {
    getTempMoms((data) => {
      setMomsData(data);
    });
  };

  const getAllContacts = () => {
    getContacts((data) => {
      const site_contacts = data.data.filter(
        (e) => e.user.site_id === CBEWSL_SITE
      );
      setAllContacts(site_contacts);
    });
  };

  const handleSendSMS = (message) => {
    setOpenBackdrop(!openBackdrop);
    let alert_release_id;
    if (disseminate_data.isRoutine) {
      alert_release_id = disseminate_data.release_id;
    } else {
      const { releases } = disseminate_data;
      const { release_id } = releases[0];
      alert_release_id = release_id;
    }

    const recipient_user_ids = [];
    const recipients_mobile = [];
    all_contacts.map((obj) => {
      const {
        user: { user_id },
      } = obj;
      if (!recipient_user_ids.includes(user_id)) {
        recipient_user_ids.push(user_id);
      }
      const { mobile_number } = obj;
      const { gsm_id } = mobile_number;
      if (gsm_id !== 0) {
        recipients_mobile.push(mobile_number);
      }
    });
    const {
      profile: { user_id },
    } = current_user;
    const input = {
      sender_user_id: user_id,
      recipient_list: recipients_mobile,
      recipient_user_ids,
      sms_msg: message,
      release_id: alert_release_id,
      release_details: JSON.stringify([disseminate_data]),
    };

    sendMessage(input, (callback) => {
      const { status, feedback } = callback;
      if (status) {
        // setIsOpenPromptModal(true);
        // setAlertVariant("success");
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "EWI sent!",
          confirmButtonColor: "#1976d2"
        });
        generateDashboardData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Error sending EWI, Please contact the developers.",
          confirmButtonColor: "#1976d2"
        });
      }
      setOpenBackdrop(false);
    });
  };

  const openOnDemandForm = () => {
    setIsOpenOndemandModal(true);
  };

  // useEffect(() => {
  //     if (is_validated) {
  //         generateDashboardData();
  //         setIsValidated(false)
  //     }
  // }, [is_validated])

  const [audio] = useState(new Audio(NotificationSoundFolder));

  useEffect(() => {
    if (is_open_new_alert_modal) audio.play();
    else {
      audio.pause();
      audio.currentTime = 0;
    }
  }, [is_open_new_alert_modal]);

  useEffect(() => {
    generateDashboardData();
    generateMomsForValidation();
    getAllContacts();
    const data = localStorage.getItem("bak_credentials");
    setCurrentUser(JSON.parse(data));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      generateDashboardData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Fragment>
      <GroundMeasurementReminderPanel
        setIsOpenGroundMeasReminder={setIsOpenGroundMeasReminder}
        is_open_ground_meas_reminder={is_open_ground_meas_reminder}
        onGoingAlerts={on_going_alerts}
        extendedAlerts={extended_alerts}
        routine={routine}
        groundMeasReminder={ground_measurement_reminder}
      />

      <HeaderAlertInformation
        onGoingData={on_going_alerts}
        routineData={routine}
        ewiTemplates={cbewsl_ewi_template}
      />

      <Grid
        item
        xs={12}
        style={{
          width: "95%",
          marginLeft: 38,
          padding: 10,
          alignItems: "center",
        }}
      >
        <Grid container>
          <Grid item md={6}>
            <Typography variant="h4">Pending Alert Validation</Typography>
          </Grid>
          <Grid item md={6}>
            <div>
              <Button
                variant="contained"
                size="small"
                onClick={openOnDemandForm}
                endIcon={<Landscape />}
                style={{
                  marginLeft: 5,
                  float: "right",
                  backgroundColor: "#ffd400",
                  color: "black",
                }}
              >
                <b>Insert On-demand</b>
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
      {candidate_alerts.length > 0 ? (
        candidate_alerts.map((row, index) => {
          return (
            <PendingAccordionPanel
              data={row}
              handleChange={handleChange}
              expanded={expanded}
              navigate={navigate}
              setTriggers={setTriggers}
              setAlertTrigger={setAlertTrigger}
              setIsOpenValidationModal={setIsOpenValidationModal}
              handleRelease={handleRelease}
            />
          );
        })
      ) : (
        <div>
          <Typography variant="body1" style={{ textAlign: "center" }}>
            No pending alerts
          </Typography>
        </div>
      )}
      <Grid
        item
        xs={12}
        style={{ width: "95%", marginLeft: 38, padding: 10, marginTop: 30 }}
      >
        <Typography variant="h4">Event Monitoring</Typography>
      </Grid>
      {on_going_alerts.length > 0 ? (
        on_going_alerts.map((row, index) => {
          return (
            <LatestAccordionPanel
              data={row}
              key={index}
              handleChange={handleChange}
              handleDisseminate={handleDisseminate}
              expanded={expanded}
            />
          );
        })
      ) : (
        <div>
          <Typography
            variant="body1"
            style={{ textAlign: "center", marginBottom: 30 }}
          >
            No event monitoring
          </Typography>
        </div>
      )}

      {routine.released_sites.length > 0 && (
        <Grid
          item
          xs={12}
          style={{ width: "95%", marginLeft: 38, padding: 10, marginTop: 30 }}
        >
          <Typography variant="h4">Routine Monitoring</Typography>
        </Grid>
      )}

      {routine.released_sites.length > 0 &&
        routine.released_sites.map((row, index) => {
          return (
            <LatestAccordionPanel
              data={row}
              key={index}
              handleChange={handleChange}
              handleDisseminate={handleDisseminate}
              expanded={expanded}
              isRoutine={true}
            />
          );
        })}

      {extended_alerts.length > 0 && (
        <Grid
          item
          xs={12}
          style={{ width: "95%", marginLeft: 38, padding: 10, marginTop: 30 }}
        >
          <Typography variant="h4">Extended Monitoring</Typography>
        </Grid>
      )}

      {extended_alerts.length > 0 &&
        extended_alerts.map((row, index) => {
          return (
            <ExtendedAccordionPanel
              data={row}
              key={index}
              handleChange={handleChange}
              handleDisseminate={handleDisseminate}
              expanded={expanded}
            />
          );
        })}

      <Grid>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 99999 }}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Grid>

      <ValidationModal
        isOpen={is_open_validation_modal}
        setOpenModal={setIsOpenValidationModal}
        trigger={alert_trigger}
        triggers={triggers}
        setTriggers={setTriggers}
        alertTrigger={alert_trigger}
        handleValidation={handleValidation}
        setNotifMessage={setNotifMessage}
        capitalizeFirstLetter={capitalizeFirstLetter}
        setIsValidated={setIsValidated}
        generateDashboardData={generateDashboardData}
      />
      <AlertReleaseFormModal
        isOpen={is_open_release_modal}
        setOpenModal={setIsOpenReleaseModal}
        trigger={alert_trigger}
        latest_overdue
        handleSubmitRelease={handleSubmitRelease}
        setNotifMessage={setNotifMessage}
        monitoringReleases={monitoring_releases}
        setMonitoringReleases={setMonitoringReleases}
        generateDashboardData={generateDashboardData}
        capitalizeFirstLetter={capitalizeFirstLetter}
      />
      <NewAlertsModal
        isOpen={is_open_new_alert_modal}
        setOpenModal={setIsOpenNewAlertModal}
        setIsOpenValidationModal={setIsOpenValidationModal}
        triggers={triggers}
        candidateAlertsData={candidate_alerts}
        capitalizeFirstLetter={capitalizeFirstLetter}
      />
      <PromptModal
        isOpen={is_open_prompt_modal}
        setOpenModal={setIsOpenPromptModal}
        handleValidation={handleValidation}
        notifMessage={notif_message}
        alertVariant={alert_variant}
      />
      <DisseminateModal
        isOpen={is_open_disseminate_modal}
        setOpenModal={setIsOpenDisseminateModal}
        disseminateData={disseminate_data}
        triggers={triggers}
        setTriggers={setTriggers}
        handleSendSMS={handleSendSMS}
        setNotifMessage={setNotifMessage}
        monitoringReleases={monitoring_releases}
        setMonitoringReleases={setMonitoringReleases}
        capitalizeFirstLetter={capitalizeFirstLetter}
        ewiTemplates={cbewsl_ewi_template}
      />
      <UpdateMomsModal
        isOpen={is_open_update_moms_modal}
        setOpenModal={setIsOpenUpdateMomsModal}
        selectedMomsData={selected_moms_data}
        setSelectedMomsData={setSelectedMomsData}
        generateMomsForValidation={generateMomsForValidation}
        setNotifMessage={setNotifMessage}
        setAlertVariant={setAlertVariant}
        setIsOpenPromptModal={setIsOpenPromptModal}
      />
      <OnDemandModal
        isOpen={is_open_ondemand_modal}
        setOpenModal={setIsOpenOndemandModal}
        generateDashboardData={generateDashboardData}
        notifMessage={notif_message}
        setNotifMessage={setNotifMessage}
        setIsOpenPromptModal={setIsOpenPromptModal}
        setAlertVariant={setAlertVariant}
      />
    </Fragment>
  );
}

export default OpCen2;
